<template>
  <modal
    id="transitionSupport"
    name="transitionSupport"
    role="dialog"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-content"
    class="m-full"
    :width="1130"
    height="auto"
    @before-close="handleClosePopUp"
  >
      <div class="dialog__inner over-flow-auto">
          <div id="dialog-content" class="dialog__content">
              <div class="container section">
                  <div class="text padding-inline-0 text-marker-star">
                      ‘본 신청’ 이후 요금제 변경, 계약 해지 등의 경우 지원금 반환금이 청구될 수 있습니다.
                  </div>
                  <p class="text text-indent-left">
                      공시지원금 및 유통망 추가지원금에 대한 반환금 산정 등은 ‘본 신청’의 약관 내용에 따르고, <span class="text-underlined">전환지원금에 대한 반환금 산정 등은 아래 사항에 따릅니다.</span>
                  </p>
                  <p class="small-text">
                      (*요금제 변경, 계약 해지 등의 경우 약관 내용에 따른 「공시지원금 및 유통망 추가지원금에 대한 반환금」 + 「‘전환지원금 및 유통망 추가지원금에 대한 반환금」 이 합산 청구됨)
                  </p>
              </div>
              <button
                      type="button"
                      class="btn_popup_close"
                      data-dismiss="modal"
                      title="팝업닫기"
                      @click="handleClosePopUp"
              >
                  <span>팝업 닫기</span>
              </button>
              <div class="section">
                 <table>
                     <tr>
                         <th class="width-15 padding-5"><p class="text color-black text-bolder">플랜 구분</p></th>
                         <th><p class="text color-black text-bolder">우선 적용 사항</p></th>
                     </tr>
                     <tr>
                         <td><p class="text text-bolder">베이직플랜</p></td>
                         <td class="padding-10">
                             <p class="text  text-color-red text-bolder">’24년 3월 16일 ~ 8월 21일 가입 고객 : 요금제 상향 시 (+) 정산금이 추가 지급되지 않습니다.</p>
                             <p class="text  text-color-red text-bolder">’24년 8월 22일 ~ 가입 고객 : 공시지원금과 동일하게 운영 (요금제 상향 시 (+) 정산금 지급됨)</p>
                         </td>
                     </tr>
                     <tr>
                         <td><p class="text text-bolder">식스플랜</p></td>
                         <td class="padding-10">
                             <p class="text">180일 이후 5G 시니어 B형 / C형로의 하향 시에만 (-) 정산금 면제됩니다.
                             </p>
                             <p class="text">
                                 (그 외 요금제 면제 미운영)
                             </p>
                         </td>
                     </tr>
                 </table>
              </div>
              <div class="section">
                  <p class="text text-bolder padding-3 padding-left-15">
                      [전환지원금 반환금 산정식]
                  </p>
                  <table>
                      <tr>
                          <th class="text color-black width-8"> <div class="text text-bolder">변경</div> <div class="text text-bolder">시기</div></th>
                          <th class="width-10 height-45 color-black"><div class="text text-bolder">작업 구분</div></th>
                          <th class="width-42 text color-black text-bolder">베이직플랜</th>
                          <th class="width-42 text color-black text-bolder">식스플랜</th>
                      </tr>
                      <tr>
                          <td rowspan="2">
                              <div>180일</div>
                              <div>이내</div>
                          </td>
                          <td class="padding-10"><p class="text text-center">해지</p></td>
                          <td colspan="2" class="padding-10">
                              <p class="text">전환지원금 전액 – 정산금 발생</p>
                          </td>
                      </tr>
                      <tr>
                          <td class="padding-25 height-60">
                              <div><p class="text">요금제</p></div>
                              <div><p class="text">변경</p></div>
                          </td>
                          <td class="padding-20">
                              <div class="grid-gap">
                                  <div>
                                      <p class="text">변경 전/후 전환지원금 차액 – 정산금 발생</p>
                                  </div>
                                  <div>
                                      <div class="text text-color-blue">(‘24.3.16 ~ ’24.8.21 가입고객) : (+) 정산금 미지급</div>
                                      <div class="text text-color-blue">(’24.8.22 ~ 가입고객) : (+) 정산금 지급</div>
                                  </div>
                              </div>

                          </td>
                          <td class="padding-20">
                              <div>
                                  <div class="padding-10 padding-bottom-25">
                                      <p class="text">변경 전/후 전환지원금 차액 – 정산금 발생</p>
                                  </div>
                                  <div class="padding-10">
                                      <p class="text text-color-blue">(요금제 상향 시) : (+) 정산금 미지급</p>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <td rowspan="2">
                              <div>180일</div>
                              <div>이후</div>
                          </td>
                          <td><p class="text text-center padding-7">해지</p></td>
                          <td colspan="2">
                              <div class="padding-10"><p class="text">기수령한 전환지원금 전액 X {(약정기간-약정 후 사용기간)/(약정기간-180일)}</p></div>
                          </td>
                      </tr>
                      <tr>
                          <td class="padding-25">
                              <div><p class="text">요금제</p></div>
                              <div><p class="text">변경</p></div>
                          </td>
                          <td class="padding-20">
                              <div class="grid-gap">
                                  <div>
                                      <div class="text">
                                          변경 전/후 전환지원금 차액 – 정산금 발생
                                      </div>
                                      <div class="text">
                                          X {(약정기간-약정 후 사용기간)/(약정기간-180일)}
                                      </div>
                                  </div>
                                  <div>
                                      <div class="text text-color-blue">
                                          (‘24.3.16 ~ ’24.8.21 가입고객) : (+) 정산금 미지급
                                      </div>
                                      <div class="text text-color-blue">
                                          (’24.8.22 ~ 가입고객) : (+) 정산금 지급
                                      </div>
                                  </div>
                              </div>
                          </td>
                          <td class="padding-20">
                              <div class="grid-gap">
                                  <div>
                                      <p class="text">
                                          별도의 – 정산금 없이 변경 가능
                                      </p>
                                  </div>
                                  <div>
                                      <div class="text font-size-14">
                                          단, 변경하려는 요금제가
                                      </div>
                                      <div class="text font-size-14">
                                          전환지원금 지급 단말 기준 5G 45,000원 미만,
                                      </div>
                                      <div class="text font-size-14">
                                          LTE 26,400원 미만
                                          인 경우
                                      </div>
                                      <div class="text font-size-14">
                                          베이직플랜과 동일하게 - 정산금 발생
                                      </div>
                                      <div class="text font-size-12">
                                          (단, 5G 시니어 B형/C형 요금제는 위약금 면제, 그 외 요금제 면제 미운영)
                                      </div>
                                  </div>
                              </div>
                          </td>
                      </tr>
                  </table>
              </div>
              <div class="section">
                  <p class="text text-marker-custom">
                      ㈜LG유플러스는 위의 산식에 따라 산정된 지원금 반환금(이하 ‘반환액’)을 청구합니다.
                  </p>
                  <p class="text text-marker-custom">
                      전환지원금 운영 모델 / 요금제 및 미운영 모델 / 요금제는 ‘홈페이지 안내’를 참고하여 주시기 바랍니다.
                  </p>
              </div>
              <div class="grid-button-footer-container">
                  <button @click="handleConfirmPopup" type="button" class="primary-button">
                      확인
                  </button>
              </div>
          </div>
      </div>
  </modal>
</template>

<script>
    export default {
        name: 'TransitionSupportPopup',

        // open modal instantly after component is mounted
        mounted() {
            this.$modal.show('transitionSupport')
        },

        // emit a function to parents to handle close the modal
        methods: {
            handleClosePopUp() {
                this.$emit('close');
            },

            handleConfirmPopup() {
                this.$emit('confirm');
            },
        },

        // hide the modal after component is unmounted
        destroyed() {
            this.$modal.hide('transitionSupport')
        }

    }
</script>

<style scoped>

    .over-flow-auto {
        overflow: auto;
    }

    .text-color-blue {
        color: blue;
    }
    .width-85 {
        width: 85%;
    }

    .width-80 {
        width: 80%;
    }

    .padding-25 {
        padding: 25px;
    }

    .padding-bottom-25 {
        padding-bottom: 25px !important;
    }

    .padding-20 {
        padding: 20px;
    }

    .padding-7 {
        padding: 7px;
    }

    .grid-gap {
        display: grid;
        gap: 15px;
    }

    .width-8 {
        width: 8%;
    }
    table {
        width: 100%;
    }
    table, th, td {
        border: 1px solid black;
        border-collapse: collapse;
    }


    th {
        text-align: center;
        background-color: #f2f2f2;
        color: white;
        height: 25px;
    }

    td:first-child {
        text-align: center;
    }

    .dialog__content {
        padding: 50px;
    }
    .container {
        display: inline;
    }
    .text {
        font-size: 15px;
        font-weight: 400;
    }

    .color-black {
        color: black;
    }

    .text-bolder {
        font-weight: 900;
    }

    .text-indent-left {
        text-indent: 10px;
    }

    .text-indent-far-left {
        text-indent: 30px;
    }

    .font-size-14 {
        font-size: 14px;
        font-weight: 400;
    }
    .small-text {
        font-size: 13.2px;
        font-weight: 400;
    }
    .font-size-12 {
        font-size: 12px;
        font-weight: 400;
    }
    .text-underlined {
        text-decoration: underline;
    }

    li {
        list-style-type: square;
        padding-inline-start: 10px;
    }

    div.text-marker-star:before {
        content: '※'
    }

    .text-marker-custom:before {
        content: '*';
    }

    .text-align-left {
        text-align: left !important;
    }


    .grid-container {
        display: grid;
        gap: 30px;
    }

    .text-container-width-70 {
        width: 70%;
    }

    .text-color-red {
        color: red;
    }

    .padding-left-15 {
        padding-left: 15px !important;
    }

    .padding-3 {
        padding: 3px;
    }

    .padding-5 {
        padding: 5px;
    }

    .padding-10 {
        padding: 10px;
    }

    .width-15 {
        width: 15%;
    }

    .width-10 {
        width: 10%;
    }

    .width-42 {
        width: 42%;
    }

    .height-45 {
        height: 45px;
    }

    .height-100 {
        height: 100px;
    }

    .height-60 {
        height: 60px;
    }

    .height-190 {
        height: 190px;
    }

    .height-40 {
        height: 40px;
    }

    .block {
        display: block;
    }

    .padding-inline-0 {
        padding-inline-start: 0;
    }

    .grid-button-footer-container {
        display: grid;
        justify-content: center;
        padding-top: 20px;
    }



</style>
